import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  LOGIN_USER_MICROSOFT,
  LOGOUT_USER,
} from "../actions";

export const loginUser = (user, history) => ({
  type: LOGIN_USER,
  payload: { user, history },
});
export const loginUserSuccess = (user) => ({
  type: LOGIN_USER_SUCCESS,
  payload: user,
});
export const loginUserError = (message) => ({
  type: LOGIN_USER_ERROR,
  payload: { message },
});
export const loginUserMicrosoft = (history, accessToken, idToken) => ({
  type: LOGIN_USER_MICROSOFT,
  payload: { history, accessToken, idToken },
});
export const logoutUser = (history) => ({
  type: LOGOUT_USER,
  payload: { history },
});
